export default __webpack_public_path__ + "static/media/need-help-img.77c9077b.svg";